import React, { useCallback } from 'react'
import {
  BoardModalView,
  ViewBody
} from 'components/Sidebar'
import { FormattedMessage } from 'react-intl'
import * as ActivityDetailLevel from 'const/ActivityDetailLevel'
import Scrollbars from 'components/Scrollbars'
import {
  ModalMenu
} from 'components/Modal'
import {
  MenuItem
} from 'components/Menu'
import Activities from '../../Activities'
import classes from './Activities.module.scss'
import { useSelector, useDispatch } from 'react-redux'
import { sagaActions as rootSagaActions } from 'store/sagas'


const DETAIL_LEVELS = [
  {
    id: ActivityDetailLevel.ALL,
    formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_ALL'
  },
  {
    id: ActivityDetailLevel.IMPORTANT,
    formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_IMPORTANT'
  },
  {
    id: ActivityDetailLevel.COMMENTS,
    formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_COMMENTS'
  }
]

const SidebarActivities: React.FC<React.ComponentPropsWithoutRef<typeof Activities>> = (props) => {
  const activitiesDetailLevel = useSelector<any, number>(state => state.kanbo.currentUser.settings.activitiesDetailLevel)

  const dispatch = useDispatch()

  const requestChangeUserSettings = useCallback(
    (...args) => dispatch(rootSagaActions.requestChangeUserSettings(...args)),
    [dispatch]
  )
  
  return (
    <BoardModalView
      title={<FormattedMessage id='ACTIVITY_STREAM_HEADER' />}
    >
      <ViewBody
        className={classes.detailLevel}
      >
        <FormattedMessage id='ACTIVITY_DETAIL_LEVEL' />:
        {' '}
        <ModalMenu
          attachment='top center'
          targetAttachment='bottom center'
        >
          <a>
            <FormattedMessage
              id={
                DETAIL_LEVELS
                  .find(detailLevel => detailLevel.id === activitiesDetailLevel)?.formattedMessageId
              }
            />
          </a>
          {DETAIL_LEVELS.map(detailLevel =>
            <MenuItem
              key={detailLevel.id}
              active={detailLevel.id === activitiesDetailLevel}
              onClick={() => {
                requestChangeUserSettings({
                  activitiesDetailLevel: detailLevel.id
                })
              }}
            >
              <FormattedMessage
                id={detailLevel.formattedMessageId}
              />
            </MenuItem>
          )}
        </ModalMenu>
      </ViewBody>
      <Scrollbars
        component={ViewBody}
        className={classes.activities}
      >
        <Activities {...props} />
      </Scrollbars>
    </BoardModalView>
  )
}

export default SidebarActivities